// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zpdncdwskzcjhbaskrjz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpwZG5jZHdza3pjamhiYXNrcmp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQxNjg4NzgsImV4cCI6MjA0OTc0NDg3OH0.hvJjjf41RkQNCT_EgaGTUeYbb99KuAvFNa7K-B-xiA0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);